import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { Popup } from '../../../../../common/popup'
import TextEllipsis from '../../../../../common/textEllipsis'
import { changeIsShowPopupCancel } from '../store/slice'
import { SelectedCompany } from './SelectedCompany'
import { selectSelectedCompanyList } from './store/slice'
import { TabsTable } from './TabsTable'

export const RecommendationList = ({ isShow, setShow }) => {
  const dispatch = useDispatch()

  const selectedCompanyList = useSelector(selectSelectedCompanyList)

  const handleClose = () => {
    setShow()
  }

  const handleClosePopup = () => {
    if (selectedCompanyList.length > 0) {
      dispatch(changeIsShowPopupCancel(true))
    } else {
      setShow()
    }
  }

  return (
    isShow && (
      <Popup
        appendStyleModal={{
          width: '80%',
          minWidth: 1024,
          height: '75%',
          minHeight: 600,
        }}
        appendStyleContent={{
          backgroundColor: '#F3F3F3',
          borderRadius: 4,
          padding: 20,
        }}
      >
        <div className="wh100 flexColumn">
          <Element
            className="dFlex justifyContentBetween alignItemsCenter pb1"
            style={{ borderBottom: '1px solid #e5e5e8' }}
          >
            <TextEllipsis
              isI18n
              zIndexTooltip={7}
              className="fw500"
              text={'companyAnalysis.peerAnalysis.RECOMMENDATION_LIST'}
              appendStyle={{
                fontSize: 20,
                color: '#0553A5',
              }}
            />
            <Icon
              className="icon-delete"
              style={{ color: '#9C9C9C' }}
              onClick={handleClosePopup}
            />
          </Element>

          <div className="flex1 dFlex">
            <TabsTable />
            <SelectedCompany handleClose={handleClose} />
          </div>
        </div>
      </Popup>
    )
  )
}
